var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError, resolveQueryFieldsTransformationPaths, } from '@wix/metro-runtime/velo';
import * as ambassadorWixLoyaltyCheckoutexchangeV1LoyaltyCheckoutDiscount from '@wix/ambassador-loyalty-checkoutexchange-v1-loyalty-checkout-discount/http';
// @ts-ignore
import { wrapWithQueryBuilder } from '@wix/motion-edm-autogen-query-wrapper';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var DiscountStatus;
(function (DiscountStatus) {
    /** Status is unknown or not specified. */
    DiscountStatus["UNKNOWN"] = "UNKNOWN";
    /** Discount has been applied to the checkout. */
    DiscountStatus["APPLIED"] = "APPLIED";
    /** Discount application is in progress. */
    DiscountStatus["IN_PROGRESS"] = "IN_PROGRESS";
    /** Discount has been successfully completed. */
    DiscountStatus["COMPLETED"] = "COMPLETED";
    /** Discount has been refunded. */
    DiscountStatus["REFUNDED"] = "REFUNDED";
    /** Attempt to refund the discount failed. */
    DiscountStatus["FAILED_TO_REFUND"] = "FAILED_TO_REFUND";
    /** Discount was refunded due to a timeout. */
    DiscountStatus["REFUNDED_DUE_TO_TIMEOUT"] = "REFUNDED_DUE_TO_TIMEOUT";
    /** Discount was refunded due to manual removal. */
    DiscountStatus["REFUNDED_DUE_TO_MANUAL_DISCOUNT_REMOVAL"] = "REFUNDED_DUE_TO_MANUAL_DISCOUNT_REMOVAL";
    /** Discount is scheduled for refund. */
    DiscountStatus["SCHEDULED_FOR_REFUND"] = "SCHEDULED_FOR_REFUND";
    /** Discount was not used. */
    DiscountStatus["UNUSED"] = "UNUSED";
})(DiscountStatus || (DiscountStatus = {}));
export var DiscountType;
(function (DiscountType) {
    /** Discount type is unknown or not specified. */
    DiscountType["UNKNOWN"] = "UNKNOWN";
    /** A discount from a flexible reward. */
    DiscountType["DISCOUNT_AMOUNT"] = "DISCOUNT_AMOUNT";
    /** A discount from a redeemed loyalty program coupon. */
    DiscountType["LOYALTY_COUPON"] = "LOYALTY_COUPON";
    /** A discount from a coupon reward that has not yet been redeemed. */
    DiscountType["COUPON_REWARD"] = "COUPON_REWARD";
    /** A discount from a referral reward. */
    DiscountType["REFERRAL_REWARD"] = "REFERRAL_REWARD";
})(DiscountType || (DiscountType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
const _applyDiscountToCheckoutRequest = {};
const _applyDiscountToCheckoutResponse = {};
const _queryLoyaltyCheckoutDiscountsRequest = {};
const _queryLoyaltyCheckoutDiscountsResponse = {};
/**
 * Applies a discount to a checkout.
 *
 * You can apply one of the following discounts, which are exchanged for loyalty points: `reward`, `loyaltyCoupon`, or `referralReward`.
 *
 * See the [introduction](https://dev.wix.com/docs/rest/crm/loyalty-program/checkout/introduction) article for more information on the type of rewards.
 * @param checkoutId - ID of the checkout to apply the discount to.
 * @public
 * @documentationMaturity preview
 * @requiredField checkoutId
 * @returns Response after applying a discount to a checkout.
 */
export function applyDiscountToCheckout(checkoutId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            checkoutId: '$[0]',
            reward: '$[1].reward',
            loyaltyCoupon: '$[1].loyaltyCoupon',
            referralReward: '$[1].referralReward',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _applyDiscountToCheckoutRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _applyDiscountToCheckoutResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['discount']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([checkoutId, options]);
        const reqOpts = ambassadorWixLoyaltyCheckoutexchangeV1LoyaltyCheckoutDiscount.applyDiscountToCheckout(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'checkoutId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a list of loyalty checkout discounts, given the provided paging, filtering, and sorting.
 *
 * To learn about working with Query methods, see
 * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language),
 * [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/pagination),
 * and [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 * @public
 * @documentationMaturity preview
 * @permissionId LOYALTY.QUERY_CHECKOUT_DISCOUNTS
 */
export function queryLoyaltyCheckoutDiscounts() {
    const requestTransformation = { '*': '$[1]', query: '$[0]' };
    const responseTransformation = {
        items: '$.loyaltyCheckoutDiscounts',
        pagingMetadata: '$.pagingMetadata',
    };
    // @ts-ignore
    const { httpClient, sideEffects, additionalHeaders } = arguments[0];
    const { toAmbassadorRequest } = serializer({
        rootSchema: _queryLoyaltyCheckoutDiscountsRequest,
        depSchemas: {},
        fqdnTransformation: {
            paths: [],
            transformation: _fromVeloEntity,
        },
        customTransformation: requestTransformation,
    });
    const { fromJSON } = serializer({
        rootSchema: _queryLoyaltyCheckoutDiscountsResponse,
        depSchemas: {},
        fqdnTransformation: {
            paths: [...['Array#loyaltyCheckoutDiscounts']],
            transformation: _toVeloEntity,
        },
        customTransformation: responseTransformation,
    });
    return wrapWithQueryBuilder({
        func: (payload) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const reqOpts = ambassadorWixLoyaltyCheckoutexchangeV1LoyaltyCheckoutDiscount.queryLoyaltyCheckoutDiscounts(payload);
            const reqOptionWithHeadersWrapper = (args) => {
                const result = reqOpts(args);
                if (additionalHeaders) {
                    const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                    return Object.assign(Object.assign({}, result), { headers });
                }
                return result;
            };
            (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
            try {
                const result = yield httpClient.request(reqOptionWithHeadersWrapper);
                (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
                return result;
            }
            catch (err) {
                (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
                throw err;
            }
        }),
        requestTransformer: (...args) => toAmbassadorRequest(args),
        responseTransformer: ({ data }) => fromJSON(data),
        errorTransformer: (err) => {
            const transformedError = transformError(err, requestTransformation);
            throw transformedError;
        },
        pagingMethod: 'CURSOR',
        transformationPaths: resolveQueryFieldsTransformationPaths(_toVeloEntity),
    })({ cursorWithEmptyFilterAndSort: true });
}
//# sourceMappingURL=loyalty-checkoutexchange-v1-loyalty-checkout-discount.universal.js.map